import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Table,
  Form,
  Button,
  Alert
} from "react-bootstrap";
import { FaPlus, FaTrash, FaEdit, FaEye, FaExclamationTriangle } from "react-icons/fa";
import { usePagination } from "../hooks/usePagination";
import Pagination from "../Components/Pagination";
import "./CustomerList.css";
import axios from "axios";

const parseDateDMY = (value) => {
  if (!value) return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return new Date(value);
  const sep = value.includes("-") ? "-" : value.includes("/") ? "/" : null;
  if (sep) {
    const parts = value.split(sep);
    if (parts.length === 3 && parts[2].length === 4) {
      const d = parseInt(parts[0], 10);
      const m = parseInt(parts[1], 10) - 1;
      const y = parseInt(parts[2], 10);
      const dt = new Date(y, m, d);
      return isNaN(dt) ? null : dt;
    }
  }
  const dt = new Date(value);
  return isNaN(dt) ? null : dt;
};

const PermissionLeaveList = () => {
  const [leaveRequests, setLeaveRequests] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState(""); // yyyy-mm-dd
  const [toDate, setToDate] = useState("");
  const [alert, setAlert] = useState({
    show: true,
    type: "success", // can be "success", "danger", "info", "warning"
    message: "Leave request submitted successfully!"
  });

  // const handleRemove = (id) => {
  //   setLeaveRequests(leaveRequests.filter((req) => req.leave_id !== id));
  // };
  const handleRemove = (leave_id) => {
    // setCustomers(customers.filter((c) => c.user_id !== user_id));
    axios.post(`${API_BASE_URL}leave_permission_delete.php`, { leave_id: leave_id })
      .then((response) => {
        if (response.data.head.code === 200) {
          // setCustomers(response.data.body);
          // setFilteredOrders(response.data.body);
          window.location.reload();

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          // setCustomers([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        // setCustomers([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  };

  const getStatusClass = (status) => {
    const s = String(status || "").toLowerCase();
    if (s === "pending") return "status-badge status-pending";
    if (s === "approved" || s === "granted" || s === "accepted")
      return "status-badge status-approved";
    if (s === "rejected" || s === "declined")
      return "status-badge status-rejected";
    if (s === "in progress" || s === "in-progress")
      return "status-badge status-progress";
    if (s === "cancelled" || s === "cancel")
      return "status-badge status-cancelled";
    if (s === "completed") return "status-badge status-completed";
    return "status-badge status-default";
  };

  const formatDateDuration = (request) => {
    // if (request.type === "Permission" && request.duration) {
    //   return `${request.leave_date} / ${request.duration} hr`;
    // } else {
    return `${request.leave_date} / ${request.duration}`;
    // }
    // return request.leave_date;
  };

  // filter logic: search across fields + optional date range
  const filtered = leaveRequests.filter((req) => {
    const q = search.trim().toLowerCase();

    const matchesSearch =
      !q ||
      String(req.leave_id).includes(q) ||
      (req.name && req.name.toLowerCase().includes(q)) ||
      (req.duration && req.duration.toLowerCase().includes(q)) ||
      (req.leave_date && req.leave_date.toLowerCase().includes(q)) ||
      (req.type && req.type.toLowerCase().includes(q)) ||
      (req.reason && req.reason.toLowerCase().includes(q)) ||
      (req.work_adjustment_name && req.work_adjustment_name.toLowerCase().includes(q)) ||
      (req.status && req.status.toLowerCase().includes(q)) ||
      (req.action_by_name && req.action_by_name.toLowerCase().includes(q)) ||
      (req.desig_name && req.desig_name.toLowerCase().includes(q)) ||
      (req.date && req.date.toLowerCase().includes(q));

    if (!matchesSearch) return false;

    if (fromDate || toDate) {
      const reqDate = parseDateDMY(req.leave_date);
      if (!reqDate) return false;
      if (fromDate) {
        const from = new Date(fromDate + "T00:00:00");
        if (reqDate < from) return false;
      }
      if (toDate) {
        const to = new Date(toDate + "T23:59:59");
        if (reqDate > to) return false;
      }
    }

    return true;
  });

  // Pagination over filtered results (4 per page)
  const {
    currentPage,
    totalPages,
    currentItems,
    handlePageChange,
    indexOfFirstItem,
  } = usePagination(filtered, 25);

  useEffect(() => {
    axios.post(`${API_BASE_URL}leave_permission_list.php`)
      .then((response) => {
        if (response.data.head.code === 200 && Array.isArray(response.data.body)) {
          setLeaveRequests(response.data.body);
          // setFilteredOrders(response.data.body);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setLeaveRequests([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setLeaveRequests([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  }, []);



  return (
    <Container fluid className="my-4 outer-container">
      <h2 className="text-center">Permission / Leave Management</h2>
      {/* {currentItems.length === 0 && (
        <Container fluid className="outer-container my-4">
          <Row>
            <Col>
              <div className="not-found-box">Loading...</div>
            </Col>
          </Row>
        </Container>
      )} */}
      {/* Department Conflict Warning */}
      <Alert variant="warning" className="mb-3 warning-msg">
        <FaExclamationTriangle className="me-2" />
        <strong>Department Leave Policy:</strong> Only one staff member per department can take leave on the same date. Permission requests are not affected by this rule.
      </Alert>

      <Row className="mb-3">
        <Col md={12}>
          <div className="d-flex justify-content-end">
            <Link to="/addleave" className="btn-top">
              <FaPlus /> Add Request
            </Link>
          </div>
        </Col>
      </Row>

      {/* {alert.show && (
        <Alert variant={alert.type} className="mb-3">
          {alert.message}
        </Alert>
      )} */}



      <Row className="mb-3">
        <Col md={4} className="mb-2">
          <Form.Label>Search</Form.Label>
          <Form.Control
            placeholder="Search by name, type"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Col>

        <Col md={3} className="mb-2">
          <Form.Label>From</Form.Label>
          <Form.Control
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            placeholder="From Date"
          />
        </Col>

        <Col md={3} className="mb-2">
          <Form.Label>To</Form.Label>
          <Form.Control
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            placeholder="To Date"
          />
        </Col>

        <Col md={2} className="d-flex mt-4">
          <Button
            className="btn-top"
            onClick={() => {
              setSearch("");
              setFromDate("");
              setToDate("");
            }}
          >
            Clear Filters
          </Button>
        </Col>
      </Row>

      <div className="table-pagination-wrapper">
        <div className="table-pagination-content">
          <Table responsive bordered className="table-striped my-3 customer-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Name</th>
                <th>Type</th>
                <th>Date / Duration</th>
                <th>Work Adjustment</th>
                <th>Status</th>
                <th>Action By</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((req, i) => (
                <tr key={req.leave_id}>
                  {/* <td>{indexOfFirstItem + i + 1}</td> */}
                  <td>{currentItems.length - (indexOfFirstItem + i)}</td>
                  <td>{req.name}</td>
                  <td>{req.type}</td>
                  <td>{formatDateDuration(req)}</td>
                  <td>{req.work_adjustment_name}</td>
                  <td>
                    <span className={getStatusClass(req.status)}>{req.status}</span>
                  </td>
                  <td>{req.action_by_name} {req.action_by_desig != "" ? `(${req.action_by_desig})` : ""}</td>
                  <td>
                    <Link className="me-2" to={`/viewleave/${req.leave_id}`}>
                      <FaEye className="view-icon" />
                    </Link>
                    <Link className="me-2" to={`/editleave/${req.leave_id}`}>
                      <FaEdit className="edit-icon" />
                    </Link>
                    <FaTrash
                      className="delete-icon"
                      // onClick={() => handleRemove(req.leave_id)}
                      onClick={() => {
                        if (window.confirm("Are you sure you want to delete this?")) {
                          handleRemove(req.leave_id);
                        }
                      }}
                      style={{ cursor: "pointer" }}
                    />
                  </td>
                </tr>
              ))}

              {currentItems.length === 0 && (
                <tr>
                  <td colSpan="8" className="text-center">
                    No leave requests found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {totalPages > 1 && (
        <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
      )}
    </Container>
  );
};

export default PermissionLeaveList;
